import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requiredRole 
}) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  // Debug pour comprendre le comportement
  useEffect(() => {
    console.log('ProtectedRoute evaluation:', {
      loading,
      currentUser: currentUser ? {
        id: currentUser.id,
        role: currentUser.role,
        isAuthenticated: !!currentUser
      } : null,
      requiredRole,
      path: location.pathname
    });
  }, [loading, currentUser, requiredRole, location]);

  // Si nous sommes encore en train de charger, afficher rien ou un spinner
  if (loading) {
    return <div className="flex items-center justify-center h-screen">Chargement...</div>;
  }

  // Si l'utilisateur n'est pas connecté, rediriger vers la page de connexion
  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location.pathname }} />;
  }

  // Si un rôle est requis et que l'utilisateur n'a pas ce rôle
  if (requiredRole && currentUser?.role !== requiredRole) {
    // Rediriger vers la route principale de l'application
    return <Navigate to="/app/adblock-bypass" />;
  }

  return <>{children}</>;
};
